<template>
  <div ref="editorWrapper">
    <ckeditor
      :editor="editor"
      :config="editorConfig"
      v-model="editorData"
      @ready="onReady"
      @input="onEditorInput"
    ></ckeditor>
  </div>
</template>
<script src="https://ckeditor.com/apps/ckfinder/3.5.0/ckfinder.js"></script>

<script>
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import MyUploadAdapter from "../utils/UploadAdapter";
export default {
  name: "Editor",
  props: {
    value: {
      type: [Object, String, Array],
    },
  },
  data() {
    return {
      editorData: null,
      editor: DecoupledEditor,
      editorConfig: {
        toolbar: {
          items: [
            "heading",
            "|",
            "fontSize",
            "fontFamily",
            "|",
            "fontColor",
            "fontBackgroundColor",
            "|",
            "bold",
            "italic",
            "underline",
            "|",
            "alignment",
            "|",
            "numberedList",
            "bulletedList",
            "|",
            "outdent",
            "indent",
            "|",
            "htmlEmbed",
            "todoList",
            "link",
            "blockQuote",
            "CKFinder",
            "imageUpload",
            "insertTable",
            "mediaEmbed",
            "|",
            "undo",
            "redo",
          ],
        },
        language: "vi",
        heading: {
          options: [
            {
              model: "paragraph",
              title: "Paragraph",
              class: "ck-heading_paragraph",
            },
            {
              model: "heading1",
              view: "h1",
              title: "Heading 1",
              class: "ck-heading_heading1",
            },
            {
              model: "heading2",
              view: "h2",
              title: "Heading 2",
              class: "ck-heading_heading2",
            },
            {
              model: "heading3",
              view: "h3",
              title: "Heading 3",
              class: "ck-heading_heading3",
            },
            {
              model: "heading4",
              view: "h4",
              title: "Heading 4",
              class: "ck-heading_heading4",
            },
            {
              model: "heading5",
              view: "h5",
              title: "Heading 5",
              class: "ck-heading_heading5",
            },
            {
              model: "heading6",
              view: "h6",
              title: "Heading 6",
              class: "ck-heading_heading6",
            },
          ],
        },
        fontSize: {
          options: [12, 14, 16, 18, 20, 22, 24, 26, 28, 30],
          supportAllValues: true,
        },
        image: {
          toolbar: [
            "imageTextAlternative",
            "imageStyle:full",
            "imageStyle:side",
          ],
        },
        table: {
          contentToolbar: [
            "tableColumn",
            "tableRow",
            "mergeTableCells",
            "tableCellProperties",
            "tableProperties",
          ],
        },
        ckfinder: {
          uploadUrl:
            "https://example.com/ckfinder/core/connector/php/connector.php?command=QuickUpload&type=Images&responseType=json",
          options: {
            resourceType: "Images",
          },
          openerMethod: "popup",
        },
      },
    };
  },

  created() {},
  mounted(editor) {},
  watch: {
    value: {
      handler(after) {
        this.editorData = after;
      },
      immediate: true,
    },
  },
  methods: {
    onReady(editor) {
      this.$refs.editorWrapper.prepend(editor.ui.view.toolbar.element);
      editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
        return new MyUploadAdapter(loader);
      };
      //editor.execute('ckfinder');
    },
    onEditorInput(editor) {
      this.$emit("input", editor);
    },
  },
};
</script>
<style>
.ck-content {
  /*border:1px solid red !important;*/
}

.ck-blurred {
  border: 1px solid #d8dbe0 !important;
}

.ck-content .image-style-side {
  max-width: 50%;
  float: right;
  margin-left: var(--ck-image-style-spacing);
}

.ck-content .image.image_resized {
  max-width: 100%;
}

.ck-content .image.image_resized {
  display: block;
  box-sizing: border-box;
}

.ck-content .image.image_resized img {
  width: 100%;
}

.ck-content .image.image_resized > figcaption {
  display: block;
}
.ck-content blockquote{
    overflow: hidden;
    padding-right: 1.5em;
    padding-left: 1.5em;
    margin-left: 0;
    margin-right: 0;
    font-style: italic;
    border-left: 5px solid #ccc;
    /* content: ''; */
    border-radius: 12px;
    background-color: #f7f7f7;
    border-left: 4px solid #ED2027;
    width: 100%;
    height: 100%;
    display: block;
}
.ck-content blockquote p, 
.ck-content blockquote span,
.ck-content blockquote strong,
.ck-content blockquote i {
    margin: 5px 0;
}
.ck-content blockquote h1, 
.ck-content blockquote h2, 
.ck-content blockquote h3, 
.ck-content blockquote h4, 
.ck-content blockquote h5, 
.ck-content blockquote h6
{
    /* margin: 15px 0; */
    margin: inherit;
}
</style>